'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var disallowedIf = {};

exports.__exports = disallowedIf;
